import { MaterialIcons } from '../material-icons';
import { EMPTY_DEFAULT } from './constants';

interface CheckmarkOrEmptyProps {
  value: boolean | null | undefined;
}

/** Table-cell renderer for a boolean field: a green checkmark icon when true, EMPTY_DEFAULT when
 * false. Shared by JobHistoryTable.tsx and TeamNameHistoryTable.tsx (Regional Role/Department
 * Lead columns). */
export const CheckmarkOrEmpty = ({ value }: CheckmarkOrEmptyProps) =>
  value ? (
    <div className="size-5 mx-auto">
      <MaterialIcons iconName="check_circle" fill={true} className="text-success" fontSize="20px" />
    </div>
  ) : (
    EMPTY_DEFAULT
  );
